/**
 * Run `fn` over `items` in sequential chunks of `batchSize` (Promise.allSettled
 * per chunk, so one rejection doesn't abort). Preserves input order. Empty
 * input returns []; batchSize <= 0 throws.
 */
export async function runInBatches<T, R>(
  items: T[],
  batchSize: number,
  fn: (item: T) => Promise<R>,
): Promise<PromiseSettledResult<R>[]> {
  if (batchSize <= 0) throw new Error("batchSize must be > 0");
  if (items.length === 0) return [];
  const results: PromiseSettledResult<R>[] = [];
  for (let i = 0; i < items.length; i += batchSize) {
    const chunk = items.slice(i, i + batchSize);
    const settled = await Promise.allSettled(chunk.map(fn));
    results.push(...settled);
  }
  return results;
}
